export const mutationCreateRating = /* GraphQL */ `
  mutation CreateRating($input: AddRatingInternalInput!) {
    addRatings(input: $input) {
      message
    }
  }
`;

export const queryCandidateRatingAverage = /* GraphQL */ `
  query CandidateRatingAverage($submissionID: String!) {
    storyRating(submissionID: $submissionID) {
      average
      count
      storyID
    }
  }
`;
export const queryGetRatings = /* GraphQL */ `
  query GetRatings($submissionID: ID!) {
    coralratings(submissionID: $submissionID) {
      id
      rating
      status
      authorID
      storyID
      createdAt
    }
  }
`;
